<template>
  <div>
    <v-dialog
      v-model="open"
      width="500"
      @click:outside="$refs.audioPlayer.stop()"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="ma-2"
          color="blue darken-1"
          depressed
          outlined
          small
          v-bind="attrs"
          v-on="on"
          @click="gaLink"
        >
          <v-icon>mdi-play</v-icon>
          &nbsp; Play
          <span v-if="duration">({{ secondsToMinutes(duration) }})</span>
        </v-btn>
      </template>
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title color="secondary">Audio Player</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <div class="ma-5"><audio-player ref="audioPlayer" :src="src" /></div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import AudioPlayer from "vuetify-audio-plus";
export default {
  props: {
    src: String,
    duration: Number,
  },
  components: { AudioPlayer },
  data() {
    return {
      open: false,
    };
  },
  methods: {
    close() {
      this.$refs.audioPlayer.stop();
      this.open = false;
    },
    gaLink() {
      this.$ga.event("audio", "open", this.src, 1);
    },
    secondsToMinutes(time) {
      const seconds = time % 60;
      const minutes = (time - seconds) / 60;
      return (
        minutes +
        ":" +
        (seconds.toString().length === 1 ? "0" + seconds : seconds)
      );
    },
  },
};
</script>
